var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"edit-button-inline white--text",attrs:{"small":"","fab":"","color":_vm.theme},on:{"click":function($event){return _vm.onClick(true)}}},[_c('v-icon',{attrs:{"size":"14px"}},[_vm._v("create")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }